import Konva from 'konva';

import { Element } from '../../equipment/models/elements/element';
import { IPlanogram } from './planogram';
import { konvaSettings } from '../../equipment/models/konvaSettings';
import { PlanogramFrontBehavior } from './planogramFrontBehavior';
import { Point } from '../../core/models/point';
import { POSMaterial } from './POSMaterials/POSMaterial';
import { ProductGroup } from './product-group';

import { Utils } from '../../core/services/utils.service';

export class PlanogramBackBehavior extends PlanogramFrontBehavior {

	constructor(planogram: IPlanogram, detailedElement: Element, scale: number, beginPoint: Point) {
		super(planogram, detailedElement, scale, beginPoint);
	}

	public convertCanvasPointToPlanogram(point: Point): Point {
		const canvasXPoint: number = point.x - konvaSettings.canvasOffset - this.beginPoint.x;
		const canvasYPoint: number = point.y - konvaSettings.canvasOffset - this.beginPoint.y;

		return {
			x: Utils.round(this.planogram.stand.Width - canvasXPoint / this.scale),
			y: Utils.round(this.planogram.stand.Height - canvasYPoint / this.scale),
			z: 0
		};
	}

	public convertPlanogramPointToCanvas(point: Point): Point {
		return {
			x: Utils.round((this.planogram.stand.Width - point.x) * this.scale + konvaSettings.canvasOffset + this.beginPoint.x),
			y: Utils.round((this.planogram.stand.Height - point.y) * this.scale + konvaSettings.canvasOffset + this.beginPoint.y)
		};
	}

	public getCorrectZCoordinate(element: Element, z: number, product: ProductGroup): number {
        const beginDelta: number = Utils.round(product.getBoundingZ().min - product.begin.z);

		return Utils.round(element.getAbsoluteBoundingZ().min - beginDelta);
	}

	public getPoint(product: ProductGroup, canvasElement: Konva.Group): Point {
		const canvasXPoint: number = canvasElement.x() - konvaSettings.canvasOffset - this.beginPoint.x;
		const canvasYPoint: number = canvasElement.y() + canvasElement.height() - konvaSettings.canvasOffset - this.beginPoint.y;
		const deltaX: number = Utils.round(product.getBoundingX().min - product.begin.x);

		return {
			x: Utils.round(this.planogram.stand.Width - product.Width - canvasXPoint / this.scale - deltaX),
			y: Utils.round(this.planogram.stand.Height - canvasYPoint / this.scale),
			z: this.planogram.stand.Depth
		};
	}

	public getProductAngle(element: Element, point: Point): number {
		return 180;
	}

	public moveProducts(productGroups: Array<ProductGroup>, horizontal: number, vertical: number): boolean {
		if (!horizontal || !productGroups.length) return false;

		let movementPerformed: boolean = false;
		productGroups.forEach((pg: ProductGroup) => {
			if (pg.canMove(-horizontal)) {
				pg.move(-horizontal);
				movementPerformed = true;
			}
		});

		return movementPerformed;
	}

	public movePOSMaterials(materials: Array<POSMaterial>, horizontal: number, vertical: number): boolean {
		if ((!horizontal && !vertical) || !materials.length) return false;

		let movementPerformed: boolean = false;
		materials.forEach((m: POSMaterial) => {
			m.x = Utils.round(m.x - horizontal);
			m.y = Utils.round(m.y + vertical);
			movementPerformed = true;
		});

		return movementPerformed;
	}
}